import { Button } from '@chakra-ui/react';
import { ReactElement } from 'react';

interface DefaultPromptButtonProps {
  icon?: ReactElement;
  label: string;
  instructions: string;
  isDisabled: boolean;
  onImproveText: (instructions: string) => void;
}

export const DefaultPromptButton = ({
  icon,
  label,
  instructions,
  isDisabled,
  onImproveText,
}: DefaultPromptButtonProps) => {
  const onClick = () => onImproveText(instructions);
  return (
    <Button
      onClick={onClick}
      isDisabled={isDisabled}
      size='xs'
      borderRadius='base'
      p={3.5}
      fontWeight='normal'
      color='black'
      variant='ghost'
      border='1px solid'
      borderColor='gray.100'
      leftIcon={icon}
      w='fit-content'
      minW='min-content'
      fontSize='xs'
      _focus={{
        outlineStyle: 'none',
        boxShadow: 'none',
        bg: 'violet.50',
        border: '1px solid',
        borderColor: 'violet.700',
        color: 'violet.700',
      }}
    >
      {label}
    </Button>
  );
};
